import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

// Turbo snapshots the page synchronously on turbo:before-cache while Bootstrap hides the
// offcanvas with a 0.3s animation; without this reset "Back" restores an open menu and a locked body.
export default class extends Controller {
  connect() {
    this.reset = this.reset.bind(this)
    document.addEventListener("turbo:before-cache", this.reset)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.reset)
  }

  reset() {
    Offcanvas.getInstance(this.element)?.hide()
    this.element.classList.remove("show", "showing", "hiding")
    this.element.removeAttribute("aria-modal")
    this.element.removeAttribute("role")
    document.querySelectorAll(".offcanvas-backdrop").forEach((backdrop) => backdrop.remove())
    const body = document.body
    body.style.removeProperty("overflow")
    body.style.removeProperty("padding-right")
    body.removeAttribute("data-bs-overflow")
    body.removeAttribute("data-bs-padding-right")
  }
}
